import React, { ReactElement, ForwardedRef } from 'react';
import IconButton from '@mui/material/IconButton';
import FormatService from '../../services/format-service';
import useStylesActionButton from './action-button.styles';

const ActionButton: ReactMemoComponent = React.memo(React.forwardRef((
  props: ReactComponentProps,
  ref: ForwardedRef<HTMLElement>,
): ReactElement => {
  const COLOR_SECONDARY: ThemeColor = 'secondary';

  const {
    isRight,
    isHidden,
    isActive,
    isInline,
    isLight,
    isDisabled,
    isControl,
    withPopup,
    withOffset,
    withFixedSize,
    withNoPadding,
    withNoHighlight,
    withSmallPadding,
    withNoRipple,
    className,
    id,
    tabIndex,
    color,
    onClick,
    onMouseDown,
    onMouseUp,
    onMouseLeave,
    children,
    ...custom
  } = props;

  const { classes } = useStylesActionButton();

  const inlineClassName: string | undefined = isInline ? classes.actionButtonInline : undefined;
  const fixedSizeClassName: string | undefined = withFixedSize ? classes.actionButtonFixedSize : undefined;
  const hiddenClassName: string | undefined = isHidden ? classes.actionButtonHidden : undefined;
  const noPaddingClassName: string | undefined = withNoPadding ? classes.actionButtonNoPadding : undefined;
  const noHighlightClassName: string | undefined = withNoHighlight ? classes.actionButtonNoHighlight : undefined;
  const smallPaddingClassName: string | undefined = withSmallPadding ? classes.actionButtonSmallPadding : undefined;
  const offsetClassName: string | undefined = withOffset ? classes.actionButtonOffset : undefined;
  const lightClassName: string | undefined = isLight ? classes.actionButtonLight : undefined;
  const lightDisabledClassName: string | undefined = isLight && isDisabled
    ? classes.actionButtonLightDisabled : undefined;
  const controlClassName: string | undefined = isControl ? classes.actionButtonControl : undefined;

  return (
    <IconButton
      disabled={isDisabled}
      disableRipple={withNoRipple}
      ref={ref}
      tabIndex={tabIndex}
      color={isActive ? COLOR_SECONDARY : color}
      aria-haspopup={withPopup ? FormatService.BOOLEAN_VALUE_TRUE : undefined}
      className={FormatService.formatClassNames(classes.actionButton, inlineClassName, fixedSizeClassName,
        hiddenClassName, noPaddingClassName, noHighlightClassName, smallPaddingClassName, offsetClassName,
        lightClassName, lightDisabledClassName, controlClassName, className)}
      id={id}
      onClick={onClick}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
      onMouseLeave={onMouseLeave}
      {...custom}
    >
      {children}
    </IconButton>
  );
}));

export default ActionButton;
